import React, { FC, ReactNode } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { isPhone, SCREEN_PADDING_HORIZONTAL } from '@helpers';
import { DashboardDrilldownScope } from '@v2/pages/dashboard/common/types/drilldown';

import DashboardDrilldownHeader from './components/DashboardDrilldownHeader';
import DashboardDrilldownBreadcrumb from './components/DashboardDrilldownBreadcrumb';
import { useManageDashboardDrilldownWrapper } from './hooks/useManageDashboardDrilldownWrapper';

export interface DashboardDrilldownWrapperProps extends WithColor {
  scope: DashboardDrilldownScope;
  entityName?: string;
  headerRight?: ReactNode;
  children: ReactNode;
}

const DashboardDrilldownWrapper: FC<DashboardDrilldownWrapperProps> = ({ C, scope, entityName, headerRight, children }) => {
  const { onBack, topOffset } = useManageDashboardDrilldownWrapper();

  return (
    <View
      style={{
        flex: 1,
        paddingTop: scale(topOffset),
        paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL),
        backgroundColor: C('Background/Light/Modal'),
      }}
    >
      <DashboardDrilldownHeader onBack={onBack} containerStyle={{ marginBottom: scale(isPhone ? 26 : 36) }} />
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: scale(16),
        }}
      >
        <DashboardDrilldownBreadcrumb scope={scope} entityName={entityName} containerStyle={{ flex: 1 }} />
        {headerRight}
      </View>
      {children}
    </View>
  );
};

export default ColorWrapper(DashboardDrilldownWrapper);
